<template>
  <div class="content">
    <Nav></Nav>
    <div class="center">
      <div class="center-nav">
        <SaasSildeNav></SaasSildeNav>
      </div>
      <div class="center-message">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import SaasSildeNav from "./components/SaasSildeNav";
export default {
  name: "index",
  components: {
    Nav,
    SaasSildeNav
  }
}
</script>

<style>
</style>
<style lang="less" scoped>
.content {
  background: #F5F5FA;
  min-height: 92%;
  .center {
    padding: 0 260px;
    margin: auto;
    margin-top: 20px;
    min-width: 850px;
    min-height: 92%;
    display: flex;
    .center-message{
      width: 100%;
      margin-left: 20px;
      min-height: 1068px;
      background: #ffffff;
    }
  }
  .center-nav{
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/index.vue